import React, {Component, Fragment} from 'react';
import {
  Badge,
  Button,
  ButtonDropdown,
  Card,
  CardBody,
  CardHeader,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Tooltip
} from 'reactstrap';
import {getAARStatus} from "../../constants/AARConstants";
import {displayMilHoursMinutesFromTime, forceSingleTimeZone, formatTimeFromEpoch} from "../../util/datehelpers";
import io from "../../api/socket.io";
import {isNumber} from "../../util/numberhelpers";
import {MakeDialog} from "../../components/Shared/MakeDialog";
import CalendarEntryEditor from "../Calendar/views/CalendarEntryEditor";
import {EventClient} from "../../util/eventClient";
import moment from "moment";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';
const labelStatus = ["Not Started", "Working", "", "", "", "", "", "", "", "Submitted", "Enrolled"];

class TodaysAppointments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltips: {},
      connected: false,
      cameraList: [],
      currentRecording: {},
      chosenCalendar: props.defaultCalendar,
      dropDownList: {},
      showAddCalEntry: false,
      editID: null,
      addSelection: {}
    }
    this.socket = null;
    this.url = "https://picam.aws01.webtest.us/";
  }

  extractCameraIds(cameras) {
    let devices = [];
    cameras.map(device => devices.push(device.id));
    return devices;
  }

  componentDidMount() {
    // if (this.props.cameras.length > 0){
    //   if (this.state.connected) this.disconnect();
    //   this.connectSocketServer(this.extractCameraIds(this.props.cameras));
    // }
    EventClient.on("CALENDAR_REFRESH", () => this.refreshHandle(), "TodaysAppointments")
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.cameras.length !== this.props.cameras.length || prevProps.dataSet !== this.props.dataSet) {
      this.setState({cameraList: this.props.cameras});
      if (this.props.dataSet.length > 0 && this.props.cameras.length > 0) {
        if (this.state.connected) this.disconnect();
        this.connectSocketServer(this.extractCameraIds(this.props.cameras));
      }
    }
  }

  componentWillUnmount() {
    if (this.state.connected && this.socket) {
      this.disconnect();
      this.socket.destroy();
    }
    EventClient.off("CALENDAR_REFRESH", () => this.refreshHandle(), "TodaysAppointments")
  }

  disconnect() {
    this.socket.off('connect', function (data) {
    });
    this.socket.off('disconnect', function (data) {
    });
    this.socket.off('request', function (data) {
    });
    this.socket.off('response', function (data) {
    });
    this.socket.disconnect();
  }

  toggleCameraDropdown(cal_id) {
    const newObj = {...this.state.dropDownList}
    if (newObj.hasOwnProperty(cal_id)) {
      delete newObj[cal_id];
    } else {
      newObj[cal_id] = true
    }
    this.setState({dropDownList: newObj});
  }

  toggle(i) {
    const newArray = {
      ...this.state.tooltips || {},
      [i]: !(this.state.tooltips[i] || false)
    };
    this.setState({
      tooltips: newArray
    });
  }

  refreshHandle() {
    if (this.props.hasOwnProperty('onRefresh')) {
      this.props.onRefresh(this.state.chosenCalendar);
    }
  }

  reconnect() {
    if (this.state.connected) this.disconnect();
    this.connectSocketServer(this.extractCameraIds(this.props.cameras));
  }

  renderCameraButton(cal_id, onlineCameras, lms_id = 0) {
    if (onlineCameras.length === 0) {
      return "";
    }
    let thisCamera;
    const availableCameras = [];
    //If recording show stop for this one
    const thisRecording = onlineCameras.filter(camera => {
      // console.log(camera.cal_id);
      if (camera.status === 'recording') {
        if (String(camera.cal_id) === String(cal_id)) {
          thisCamera = camera;
          return true;
        }
        return false;
      } else {
        availableCameras.push(camera);
        return false;
      }
    });
    if (thisRecording.length > 0) {
      return <Button
        id="caret"
        color={"danger"}
        title={thisRecording[0].display}
        style={{
          height: 20,
          padding: 0,
          borderRadius: 5
        }}
        onClick={() => {
          this.sendCommand(thisCamera.id, 'stop');
        }}
      >Stop</Button>;
    }
    if (availableCameras.length > 1) {
      return <ButtonDropdown isOpen={this.state.dropDownList.hasOwnProperty(cal_id)}
                             className={"dropup"}
                             toggle={() => {
                               this.toggleCameraDropdown(cal_id);
                             }}>
        <DropdownToggle caret color={"info"}>
          Record
        </DropdownToggle>
        <DropdownMenu>
          {availableCameras.map((camera, index) => {
            return <DropdownItem key={index}
                                 onClick={() => {
                                   this.sendCommand(availableCameras[index].id, 'record', {
                                     calId: cal_id,
                                     lmsId: lms_id
                                   });
                                 }}>{camera.display || camera.id}</DropdownItem>
          })}
        </DropdownMenu>
      </ButtonDropdown>;
    } else if (availableCameras.length === 1) {
      return <Button
        id="caret"
        color={"info"}
        title={availableCameras[0].display}
        style={{
          height: 25,
          padding: 2,
          borderRadius: 5
        }}
        onClick={() => {
          this.sendCommand(availableCameras[0].id, 'record', {calId: cal_id, lmsId: lms_id});
        }}
      >Record</Button>;
    } else {
      return "";
    }
  }

  addSelection() {
    const roundedUp = Math.ceil(moment().minute() / 15) * 15;

    const start = moment().minute(roundedUp).second(0);
    const selection = {
      start: start.toDate(),
      end: start.add(1.5, 'hour').toDate()
    }
    // console.log({start: selection.start, end: selection.end});
    // this.setState({addSelection: {start: selection.start, end: selection.end}, showAddCalEntry: true})
    EventClient.emit("CALENDAR_ENTRY_ADD", {addSelection: {start: selection.start, end: selection.end}, calId: this.state.chosenCalendar})
  }

  render() {
    const onlineCameras = this.state.cameraList.filter(camera => camera.status === 'ready' || camera.status === 'recording');
    const hasCamera = this.props.dataSet.length > 0 && onlineCameras.length > 0;

    return (
      <Card style={{borderRadius: 10}}>
        <CardHeader>
          <strong>Today's Appointments</strong>
          {hasCamera && (
            <i className="icon-globe"
               style={{color: this.state.connected ? brandInfo : brandDanger}}
               title={this.state.connected ? "Camera Server Connected" : "Camera Server Not Connected"}/>
          )}
          <div className="card-actions">
            <button onClick={() => this.addSelection()}>
              <small className="text-muted">Add</small>
            </button>
            <button onClick={() => this.refreshHandle()}>
              <small className="text-muted">Refresh</small>
            </button>
          </div>
        </CardHeader>
        <CardBody>
          {this.props['calendars'] && this.props['defaultCalendar'] && this.props['calendars'].length > 1 && (
            <FormGroup>
              <Label for="list">Calendar</Label>
              <Input type="select" value={this.state.chosenCalendar} onChange={(evt) => {
                this.setState({chosenCalendar: evt.target.value});
                if (this.props.hasOwnProperty('onCalendarChange')) {
                  this.props.onCalendarChange(evt.target.value);
                }
              }}>
                <option key={0} value="">My Calendar</option>
                {this.props['calendars'].map((calendar, index) => {
                  if (calendar.cal_id === this.props.defaultCalendar) return;
                  return (
                    <option key={index + 1}
                            value={calendar.cal_id}>{`${calendar.agencyDisplay} > ${calendar.userDisplay}`}</option>
                  )
                })}
              </Input>
            </FormGroup>
          )}
          {this.props.dataSet.length === 0 ?
            <div>
              <p>No Appointments Loaded</p>
            </div>
            :
            <Table responsive size="sm">
              <Fragment>
                <thead>
                <tr>
                  <th>Who/What</th>
                  <th>When</th>
                  <th>Status</th>
                  {hasCamera && (
                    <th>Camera</th>
                  )}

                </tr>
                </thead>

                <tbody>
                {
                  this.props.dataSet.map((cal, index) => {
                    const status = getAARStatus(cal.aar_status);
                    return <tr key={index}>
                      <td>
                        <a href="javascript:void(0);"
                           onClick={() => EventClient.emit("CALENDAR_ENTRY_EDIT", {
                             eventId: cal.id,
                             calId: this.state.chosenCalendar
                           })}
                           id={`tooltip-cal-${cal.id}`}>{cal['lmsID'] !== null && `${cal['fname']}${cal['lname']}`.length > 0 ? `${cal['fname']} ${cal['lname']}` : `${cal['subject']}`}</a>
                        <Tooltip placement="top"
                                 isOpen={typeof this.state.tooltips[index] !== "undefined" && this.state.tooltips[index] === true}
                                 autohide={false}
                                 target={`tooltip-cal-${cal.id}`}
                                 toggle={() => {
                                   this.toggle(index)
                                 }}>
                          {cal.subject}
                        </Tooltip>
                      </td>
                      <td>{displayMilHoursMinutesFromTime(forceSingleTimeZone(formatTimeFromEpoch(cal.starttime)))}</td>
                      <td>
                        <Badge style={{backgroundColor: status.bgColor, color: status.color}}>{status.display}</Badge>
                      </td>
                      {hasCamera && (
                        <td>{this.renderCameraButton(cal.id, onlineCameras, cal['lmsID'] || 0)}</td>
                      )}
                    </tr>
                  })
                }
                </tbody>
              </Fragment>
              {(1 == 2) && (
                <tfoot>
                <tr>
                  <td colSpan={4}>
                    <Pagination>
                      <PaginationItem><PaginationLink previous href="#">Prev</PaginationLink></PaginationItem>
                      <PaginationItem active>
                        <PaginationLink href="#">1</PaginationLink>
                      </PaginationItem>
                      <PaginationItem><PaginationLink href="#">2</PaginationLink></PaginationItem>
                      <PaginationItem><PaginationLink href="#">3</PaginationLink></PaginationItem>
                      <PaginationItem><PaginationLink href="#">4</PaginationLink></PaginationItem>
                      <PaginationItem><PaginationLink next href="#">Next</PaginationLink></PaginationItem>
                    </Pagination>
                  </td>
                </tr>
                </tfoot>
              )}
            </Table>
          }
        </CardBody>
        {(this.state.showAddCalEntry || isNumber(this.state.editID)) && (
          <MakeDialog isOpen={(this.state.showAddCalEntry || isNumber(this.state.editID))}
                      header="Calendar Entry">
            <CalendarEntryEditor
              eventName="CalendarEntryEvent"
              saveEvent="CALENDAR_ENTRY_SAVE"
              addSelection={this.state.addSelection}
              calId={this.state.chosenCalendar}
              onSave={() => {
                this.setState({showAddCalEntry: false, editID: null, addSelection: {}}, () => {
                  this.refreshHandle()
                })
              }}
              onClose={() => {
                this.setState({showAddCalEntry: false, editID: null, addSelection: {}});
              }}
              // templates={this.state.templates['templates'] || []}
              edit={this.state.editID}
              footer={(
                <Fragment>
                  <Button color="primary"
                          onClick={() => EventClient.emit("CALENDAR_ENTRY_SAVE", null)}>Save</Button>
                  <Button color="secondary"
                          onClick={() => this.setState({showAddCalEntry: false, editID: null})}>Close</Button>
                </Fragment>
              )}/>
          </MakeDialog>
        )}
      </Card>
    )
  }

  connectSocketServer(devices) {
    let self = this;
    this.socket = io(self.url);
    console.log("Connecting to " + self.url);
    // this.socket = io("http://localhost:8080");
    this.socket.on('connect', function () {
      console.log('I am connected to camera sockets');
      self.setState({connected: true});
      self.socket.emit('request', {action: "login", type: "client", step: 0, loginId: 1, deviceIds: devices});
    });
    this.socket.on('disconnect', function () {
      console.log("Disconnected");
      self.setState({connected: false});
    });
    this.socket.on('request', function (data) {
      switch (data.action) {
        case "sethost":
          if (data['data'] && data['data']['host']) {
            self.url = data['data']['host'];
            self.disconnect();
            setTimeout(() => {
              self.reconnect();
            }, 1000);
          }
          break;
      }
    });
    this.socket.on('response', function (data) {
      // console.log(data);
      const currentState = self.state.cameraList;
      switch (data.action) {
        case "login":
          if (data.result === "Success") {
            self.socket.emit('request', {action: "devices"});
          }
          break;
        case "devices":
          data.data.map((device, index) => {
            currentState.map((currentDevice, curIndex) => {
              if (device.deviceId === currentDevice.id) {
                currentState[curIndex].status = device.status;
                currentState[curIndex].last_response = device.lastTime;
              }
            });
          });
          self.setState({cameraList: [...currentState]});
          break;
        case "device":
          currentState.map((currentDevice, curIndex) => {
            if (data.data.deviceId === currentDevice.id) {
              // console.log("device state", data);
              currentState[curIndex].status = data.data.status;
              // currentState[curIndex].cal_id = data.data['calId'] || 0;
              currentState[curIndex].last_response = data.data.lastTime;
            }
          });
          self.setState({cameraList: [...currentState]});
          break;
        case "record":
          self.setState({
            cameraList: [...currentState.map((currentDevice, curIndex) => {
              if (data.replyTo === currentDevice.id) {
                // console.log("RECORD state", data);
                return {
                  ...currentDevice,
                  status: data.state === "recording" ? "recording" : "ready",
                  cal_id: data['calId'] || 0
                };
              }
              return currentDevice;
            })]
          });
          break;
      }
    });
  }

  sendCommand(deviceId, action, addProps = {}) {
    this.socket.emit('request', {action: action, deviceId: deviceId, ...addProps});
    // console.log("requested " + action);
  }

  sendCommandUpdate(deviceId, action, data) {
    this.socket.emit('request', {action: action, deviceId: deviceId, data: data});
    // console.log("requested " + action + " using " + data);
  }
}

export default TodaysAppointments;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/TodaysAppointments.js